// The free trial, in one place.
//
// Every surface that states or enforces the size of the free first sample
// reads from here: the delivery target, the pipeline caps that have to be
// wide enough to fill it, the app and marketing copy, and the connector
// tool text. No file may restate the number.
//
// Pure constants and string helpers, no imports, so the app, the pipeline
// host, the connector tools and the tests can all share it.

/** Matched contacts delivered on a team's one free trial delivery. */
export const TRIAL_CONTACT_COUNT = 10;

/**
 * Firms promoted from the supplemental pass on a trial delivery.
 *
 * Each promoted firm yields at most a contact or two, so the cap has to
 * sit above TRIAL_CONTACT_COUNT or the trial cannot fill its own target.
 * Twenty percent of headroom, with a floor that keeps small values sane.
 */
export const TRIAL_SUPPLEMENTAL_FIRMS_CAP = Math.max(
  12,
  Math.ceil(TRIAL_CONTACT_COUNT * 1.2),
);

/**
 * Minimum Stage 2 resolution buffer on a trial delivery: how far past the
 * target contact resolution keeps going so the target is actually met
 * after unusable rows are discarded. Kept at the same proportion of the
 * target the trial has always used.
 */
export const TRIAL_STAGE2_BUFFER_MIN = Math.ceil(TRIAL_CONTACT_COUNT * 0.6);

/** "10 matched investor contacts", for copy that spells the offer out. */
export const TRIAL_CONTACTS_PHRASE = `${TRIAL_CONTACT_COUNT} matched investor contacts`;

/** "free 10-contact trial", for connector and tool text. */
export const TRIAL_OFFER_PHRASE = `free ${TRIAL_CONTACT_COUNT}-contact trial`;
